/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Title from '@mui/material/Typography';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { ERROR, SUCCESS } from 'constants/index';
import { Message, PageLoader, RenewMemberOptions } from 'components';
import { useGetFormTokenQuery, useGetRenewInformationQuery } from 'store/api/version-api.slice';
import { prepareRenewInformation } from 'adapters';

import { PaymentStatusResult } from '../dashboard/components/PaymentInformation';

import { styles } from './styles/renewMember.styles';

const RenewMemberRoute = () => {
	const params = useParams();

	const [paymentStatus, setPaymentStatus] = useState('');

	const { data: renewInfo = {}, isLoading: isRenewLoading } = useGetRenewInformationQuery({
		portalId: params.portal_id,
		contactId: params.contact_id
	});

	const { data: formToken, isLoading: isFormTokenLoading } = useGetFormTokenQuery();

	const renewInformation = useMemo(() => prepareRenewInformation({ formToken, renewInfo }), [formToken, renewInfo]);

	const paymentHasResult = [SUCCESS, ERROR].includes(paymentStatus);

	return (
		<PageLoader isLoading={isRenewLoading || isFormTokenLoading}>
			<Box sx={styles.root}>
				<CssBaseline />
				<Container maxWidth="lg">
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Title component={'div'} variant="h3" color="primary" sx={styles.title}>
								RENEW MEMBERSHIP
							</Title>
							{paymentHasResult ? (
								<Paper elevation={2} sx={styles.paper}>
									<PaymentStatusResult status={paymentStatus} />
								</Paper>
							) : (
								<RenewMemberOptions renewInfo={renewInformation} setPaymentStatus={setPaymentStatus} />
							)}
							<Message />
						</Grid>
					</Grid>
				</Container>
			</Box>
		</PageLoader>
	);
};

export default RenewMemberRoute;
